import { useNavigate } from "react-router-dom";
import { FaLock, FaArrowLeft, FaShieldAlt } from "react-icons/fa";

// Tela full-screen de acesso restrito, reutilizada pelos guards (SellerGuard,
// StoreSellerAccessGuard, AdminGuard). Segue o design system claro do projeto.
const AccessRestricted = ({
  title = "Acesso Restrito",
  badge = "Área do Vendedor",
  message = "Esta área é restrita para vendedores cadastrados.",
  secondaryMessage = "Se você é vendedor de uma loja, faça o cadastro através do link fornecido pela sua loja.",
  secondaryButton = null,
  debugInfo = null,
}) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-white rounded-xl border border-slate-200 p-5 md:p-8 shadow-sm text-center">
        <div className="mx-auto h-20 w-20 rounded-full bg-red-100 flex items-center justify-center mb-6">
          <FaLock className="text-red-600 text-3xl" />
        </div>

        <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold tracking-tight text-slate-900 mb-4">
          {title}
        </h2>

        <div className="mb-6">
          {badge && (
            <div className="flex items-center justify-center mb-4">
              <FaShieldAlt className="text-amber-500 mr-2" />
              <span className="text-sm font-medium text-amber-700">{badge}</span>
            </div>
          )}

          <p className="text-slate-600 mb-4">{message}</p>

          {secondaryMessage && (
            <p className="text-sm text-slate-500">{secondaryMessage}</p>
          )}
        </div>

        <div className="space-y-3">
          <button
            onClick={() => navigate(-1)}
            className="w-full px-6 py-3 bg-slate-700 text-white font-medium rounded-lg hover:bg-slate-800 focus:ring-2 focus:ring-slate-700/20 focus:outline-none transition-all duration-200 flex items-center justify-center"
          >
            <FaArrowLeft className="mr-2" />
            Voltar
          </button>

          {secondaryButton && (
            <button
              onClick={secondaryButton.onClick}
              className="w-full px-6 py-3 bg-slate-100 text-slate-700 font-medium rounded-lg hover:bg-slate-200 focus:ring-2 focus:ring-slate-700/20 focus:outline-none transition-all duration-200"
            >
              {secondaryButton.label}
            </button>
          )}
        </div>

        {process.env.NODE_ENV === "development" && debugInfo && (
          <div className="mt-6 p-3 bg-slate-100 rounded-lg text-left">
            <p className="text-xs text-slate-600 mb-2">
              <strong>Debug Info:</strong>
            </p>
            <p className="text-xs text-slate-500">{debugInfo}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccessRestricted;
